import callAPI from '../ApiConfig'

const getAccounts = async (props) => {
    return await callAPI({
        route: "accounts/",
        method: "get",
        signal: props?.signal,
        params: props?.params,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

const accountAPI = {
    getAccounts: getAccounts
}

export default accountAPI
